
export default class PwaService {
    
    estouOnline(){
        return navigator.onLine
    }
    
}